import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { Button } from "@trillion/ui/components/ui/button";
import { PageHeader } from "@trillion/ui/components/admin/page-header";
import { BrandForm } from "@/components/brands/brand-form";
import { adminApi } from "@/lib/admin-api";
import { describeApiError } from "@/lib/api-error";
import type { ProductBrand } from "@/types";

export function BrandNewPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit(data: Partial<ProductBrand>) {
    setIsLoading(true);
    try {
      await adminApi.brands.create(data);
      toast.success("Brand created successfully");
      navigate("/brands");
    } catch (err) {
      toast.error("Failed to create brand", {
        description: describeApiError(err),
      });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="flex flex-col gap-6 p-6">
      <PageHeader
        title="New Brand"
        description="Add a brand (advertiser/merchant) under a network"
        actions={
          <Button variant="outline" onClick={() => navigate("/brands")}>
            <ArrowLeft className="mr-2 size-4" />
            Back to Brands
          </Button>
        }
      />
      <BrandForm onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
}
